export const components = {
  Checkbox: {
    baseStyle: {
      control: {
        borderColor: 'dark.3',
      },
    },
  },
}
